module.exports = "pegasus/assets/styleGroup1-twitter.gif";